import { forwardRef, useContext } from "react"

import InputWithUnit from "./InputWithUnit/InputWithUnit"

import { LocalizationContext } from "web/contexts"
import { useUnits } from "web/hooks/data"

const AreaInput = forwardRef((props, ref) => {
  const { defaultAreaUnit } = useContext(LocalizationContext)
  const [{ area_units: areaUnits }] = useUnits()
  const supportedAreaUnitCodes = areaUnits.map((c) => c.code)

  return (
    <InputWithUnit
      ref={ref}
      kind="Area"
      units={supportedAreaUnitCodes}
      defaultUnit={defaultAreaUnit}
      {...props}
    />
  )
})

export default AreaInput
